import React from 'react';

import { Button, Icons, Positions } from '@sede-enterprise/shell-ds-react-framework';
import { useTranslation } from 'react-i18next';
import { Row, Col } from '../../components/flexbox/Flex';
import { AuthService } from '../../services/AuthService';
import './login.css';

const Login = () => {
	const authService = new AuthService();
	const { t } = useTranslation();

	const handleSignIn  = () => {
		authService.login();
	}

	return (
		<div className="login" role='main'>
			<Col size="30">
				<div className='left_container'>
					<Row>
						<img src='/logobrand.png' alt='Shell Logo' style={{width:'75%'}}/>
					</Row>

					<div className='login-btn'>
						<Button size="large" iconPosition={Positions.Right} icon={<Icons.ChevronRight />} variant="filled"  onClick={handleSignIn}> {t('signIn')} </Button>
					</div>
				</div>
			</Col>
        </div>
	)
}
export default Login;
